document.addEventListener('DOMContentLoaded', () => {
  const skipButton = document.querySelector('.btn-skip');
  skipButton.addEventListener('click', () => {
    sessionStorage.setItem("skippedOldBrowserPage", true);
    window.location.href = "/";
  });
});
